import { GameConstants } from "../../GameConstants";
import { GameVars } from "../../GameVars";
import { PlayersContainer } from "./players-container/PlayersContainer";
import { AdversaryContainer } from "./players-container/AdversaryContainer";

export class InfosLayer extends Phaser.GameObjects.Container {

    private static ADVERSARIES_POSITIONS = [
        {x: GameConstants.GAME_WIDTH / 2 - 350, y: 400},
        {x: GameConstants.GAME_WIDTH / 2 - 350, y: 220},
        {x: GameConstants.GAME_WIDTH / 2 - 30, y: 150},
        {x: GameConstants.GAME_WIDTH / 2 + 350, y: 220},
        {x: GameConstants.GAME_WIDTH / 2 + 350, y: 400}
        
    ];

    private images: Phaser.GameObjects.Image[];

    constructor(scene: Phaser.Scene, ids: string[]) {

        super(scene);

        this.images = [];

        for (let i = 0; i < GameVars.gameState.players.length - 1; i++) {

            const px = InfosLayer.ADVERSARIES_POSITIONS[i].x;
            const py = InfosLayer.ADVERSARIES_POSITIONS[i].y;

            let rightSide = px > GameConstants.GAME_WIDTH / 2;
            
            const image = new Phaser.GameObjects.Image(this.scene, px + (rightSide ? -20 * GameVars.scaleX : 20 * GameVars.scaleX), py, "texture_atlas_1", "char_file_" + ids[i] + ".png");
            image.visible = false;
            image.setScale(.9 * GameVars.scaleX, .9);
            image.name = ids[i];
            this.add(image);

            this.images.push(image);
        }
    }

    public showInfo(id: string): void {

        for (let i = 0; i < this.images.length; i++) {

            if (this.images[i].name === id) {
                this.images[i].visible = true;
            } else {
                this.images[i].visible = false;
            }
        }
    }

    public showInfoMobile(id: string): void {

        for (let i = 0; i < this.images.length; i++) {

            if (this.images[i].name === id) {
                this.images[i].visible = !this.images[i].visible;
            } else {
                this.images[i].visible = false;
            }
        }
    }

    public hideInfo(): void {

        for (let i = 0; i < this.images.length; i++) {
            this.images[i].visible = false;
        }
    }
}
